export enum PaginationNavigation {
  back = "back",
  forward = "forward",
  toPage = "toPage",
}

export interface PagesProps {
  currentPage: number;
  onPaginate: (page: number) => void;
  pageCount: number;
}
